const jssConfig = require('./src/temp/config');
const plugins = require('./src/temp/next-config-plugins') || {};

const publicUrl = jssConfig.publicUrl;

const isVercel = process.env.VERCEL === '1';

/**
 * @type {import('next').NextConfig}
 */
const nextConfig = {
  // Allow easier debugging.  We can remove if clients consider it a security risk
  // but generally it should be fine for most projects.
  productionBrowserSourceMaps: true,

  // Set assetPrefix to our public URL
  // In Vercel we need to set it to undefined for preview deployments to work
  // Since the preview url will be different from the public url
  assetPrefix: isVercel ? undefined : publicUrl,

  // Allow specifying a distinct distDir when concurrently running app in a container
  distDir: process.env.NEXTJS_DIST_DIR || '.next',

  // Make the same PUBLIC_URL available as an environment variable on the client bundle
  env: {
    PUBLIC_URL: publicUrl,

    // Only expose the SITECORE_API_HOST on localhost because proxying for media doesn't
    // work anymore from http to https in XMC.
    SITECORE_API_HOST:
      process.env.PUBLIC_URL === 'http://localhost:3000'
        ? process.env.SITECORE_API_HOST
        : undefined,
  },

  i18n: {
    // These are all the locales you want to support in your application.
    // These should generally match (or at least be a subset of) those in Sitecore.
    locales: ['en', 'es-ES'],
    // This is the locale that will be used when visiting a non-locale
    // prefixed path e.g. `/styleguide`.
    defaultLocale: jssConfig.defaultLanguage,
  },

  // See headapps\nextjs-starter\src\lib\next-config\plugins\images.js
  // images: {},

  // Enable React Strict Mode
  reactStrictMode: true,

  // Ensure proper client-side navigation
  experimental: {
    scrollRestoration: true,
  },

  // Disable the X-Powered-By header. Follows security best practices.
  poweredByHeader: false,

  async rewrites() {
    // When in connected mode we want to proxy Sitecore paths off to Sitecore
    return [
      // API endpoints
      {
        source: '/sitecore/api/:path*',
        destination: `${jssConfig.sitecoreApiHost}/sitecore/api/:path*`,
      },
      // media items
      {
        source: '/-/:path*',
        destination: `${jssConfig.sitecoreApiHost}/-/:path*`,
      },
      // healthz check
      {
        source: '/healthz',
        destination: '/api/healthz',
      },
      // rewrite for Sitecore service pages
      {
        source: '/sitecore/service/:path*',
        destination: `${jssConfig.sitecoreApiHost}/sitecore/service/:path*`,
      },
      // Add cms-hpt file required for regulatory purposes with a rewrite from the media library so that it can be modified
      {
        source: '/cms-hpt.txt',
        destination: 'https://edge.sitecorecloud.io/childrensho3e59-cw60b4-prod2126-77fc/media/CHWLIBRARY/Files/Patients-and-families/Billing-payment/cms-hpt.txt',
      }
    ];
  },
  // redirect rules for teaching sheet and providers.
  async redirects() {
    return [
      {
        source: '/home',
        destination: '/',
        permanent: true,
      },
      {
        source: '/home/:path*',
        destination: '/:path*',
        permanent: true,
      },
      {
        source: '/Publications/Teaching-Sheet/:lang/:id(\\d+-):cont',
        destination: '/teaching-sheet/:lang/:cont',
        permanent: true,
      },
      {
        source: '/es-es/Publications/Teaching-Sheet/:lang/:id(\\d+-):cont',
        destination: '/es-es/teaching-sheet/:lang/:cont',
        permanent: true,
      },
      {
        source: '/physician-directory',
        destination: '/providers',
        permanent: true,
      },
      {
        source: '/physician-directory/:cat([a-zA-Z0-9-]+)/:name([^/]+)',
        destination: '/providers/:cat/:name',
        permanent: true,
      },
      // Domain-based rules - ticket 1098
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'www.chw.org' }],
        destination: 'https://childrenswi.org',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'cssw.org' }],
        destination: 'https://childrenswi.org/who-we-are/community-programs',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'kidhero.chw.org' }],
        destination: 'https://childrenswi.org/who-we-are/community-programs/foster-care',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'skywalkpharmacy.com' }],
        destination: 'https://childrenswi.org/locations/skywalk-milwaukee',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'shinethrough.childrenswi.org' }],
        destination: 'https://childrenswi.org/find-care/mental-behavioral-health',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'verificationletters.chw.org' }],
        destination: 'https://childrenswi.org/medical-professionals/patient-referral-toolkit/staff-verification',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'blog.chw.org' }],
        destination: 'https://childrenswi.org/at-every-turn',
        permanent: true,
      },

      // New rules for givings site - ticket 1098
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'alsrun.com' }],
        destination: 'https://giving.childrenswi.org/Als-Run-Walk',
        permanent: true,
      },
      {
        source: '/:path*',
        has: [{ type: 'host', value: 'miraclemarathon.chw.org' }],
        destination: 'https://giving.childrenswi.org/events',
        permanent: true,
      },

    ];
  },
};

module.exports = () => {
  // Run the base config through any configured plugins
  return Object.values(plugins).reduce((acc, plugin) => plugin(acc), nextConfig);
};
